import script from "./NavConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./NavConfig.vue?vue&type=script&setup=true&lang=js"

import "./NavConfig.vue?vue&type=style&index=0&id=5e9bf83c&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9bf83c"]])

export default __exports__